// The role as people read it (Umer, 2026-10-07: a packager's sidebar read "worker"). Packaging House
// staff are stored as 'worker' — the id stays, RLS and the phone app key on it — and the legacy
// 'packager' accounts do the same job, so both read "packager", as the Admin Panel's role picker and
// team list already say. Every other role reads as its id with spaces: "warehouse manager".
export const roleLabel = (role: string | null | undefined): string => {
  if (!role) return '';
  if (role === 'worker' || role === 'packager') return 'packager';
  return role.replace(/_/g, ' ');
};
